import(/* webpackMode: "eager", webpackExports: ["TournamentsClient"] */ "/vercel/path0/app/[locale]/tournaments/tournaments-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/components/Footer.tsx");
